import React from 'react';

export default function CalculatorHome() {
    return (
        <div style={{height: "100vh"}}>
            
        </div>
    )
}